import { useState } from 'react';

interface CustomInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  placeholder?: string;
  label?: string;
  name?: string;
  type?: string;
  error?: string;
  touched?: boolean;
  readOnly?: boolean;
  disabled?: boolean;
}

export const CustomInput = ({
  value,
  onChange,
  onFocus,
  onBlur,
  placeholder = '',
  label = '',
  name = '',
  type = 'text',
  error,
  touched,
  readOnly,
  disabled,
}: CustomInputProps) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(true);
    onFocus?.(e);
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(false);
    onBlur?.(e);
  };

  // Don't show any errors while focused
  const shouldShowError = touched && error && !isFocused;

  return (
    <fieldset className="fieldset mb-0 gap-1">
      <legend className="fieldset-legend input-label">{label}</legend>
      <input
        type={type}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
        readOnly={readOnly}
        disabled={disabled}
        className={`input text-input w-full placeholder:text-[var(--color-text-input-placeholder)] 
          ${shouldShowError ? 'text-input-error border-input-error' : ''}`}
      />
      {shouldShowError ? <span className="input-error">{error}</span> : <></>}
    </fieldset>
  );
};
